import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'signup_personal_info.title',
  },
  subTitle: {
    id: 'signup_personal_info.sub_title',
  },
  firstName: {
    id: 'signup_personal_info.first_name',
  },
  lastName: {
    id: 'signup_personal_info.last_name',
  },
  birthday: {
    id: 'signup_personal_info.birthday',
  },
  cin: {
    id: 'signup_personal_info.cin',
  },
  email: {
    id: 'signup_personal_info.email',
  },
  phoneNumber: {
    id: 'signup_personal_info.phone_number',
  },
  haveAssuranceSante: {
    id: 'signup_personal_info.have_assurance_sante',
  },
  haveContratEpargne: {
    id: 'signup_personal_info.have_contrat_epargne',
  },
  loiParagraph: {
    id: 'signup_personal_info.loi_paragraph',
  },
  contacterParSaham: {
    id: 'signup_personal_info.contacter_par_saham',
  },
  requiredField: {
    id: 'required.field',
  },

  birthdayInputError: {
    id: 'signup_personal_info.birthday.error',
  },
  emailInputError: {
    id: 'signup_personal_info.email.error',
  },
  suivant: {
    id: 'signup_auth_button.next',
  },
  precedent: {
    id: 'signup_auth_button.previous',
  },
  validFormPhone: {
    id: 'sign_auth.phone_valid_error',
  },
  iAccept: {
    id: 'id_memo.i_accept',
  },
  termsAndConditions: {
    id: 'id_memo.terms_and_conditions',
  },
  personalData: {
    id: 'id_memo.personal_data',
  },
  modalTitle: {
    id: 'modal.Title',
  },
  close: {
    id: 'modal.close',
  },
  accept: {
    id: 'modal.accept',
  },
  conditionsGeneralError: {
    id: 'signup_personal_info.accept_conditions_utilisateur_error',
  },
  selectionnezProduit: {
    id: 'epargn.add_new_contract_selectionnez_produit',
  },
  numPolice: {
    id: 'signup_auth_contract.numero_police',
  },
  dateEffet: {
    id: 'auto_details.my_contracts.date_effet',
  },
  matricule_field: {
    id: 'epargn.add_new_contract_matricule',
  },
  ppr_field: {
    id: 'epargn.add_new_contract_ppr',
  },
  numero_adhesion: {
    id: 'epargn.add_new_contract_numero_adhesion',
  },
});
